/**
 * Globe Ping Configuration
 * How long a ping stays on the globe, and how near the camera comes when one
 * is pressed. How a ping looks is the globe's (ping/globe-ping-overlay.tsx).
 */

/**
 * Ping display and behavior settings
 */
export const PING_CONFIG = {
  /** Display duration in seconds before ping expires */
  displayDurationSeconds: 6,

  /** Camera focus settings when clicking on a ping indicator */
  cameraFocusAltitude: 1,
} as const;
